// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__g79EI","cardWrapper":"styles_cardWrapper__CDk5z"};